module.exports = __webpack_public_path__ + "img/weddings_02_H.0f9e4ff0.webp";